import { render } from "./PengumumanPemenangExecutive.vue?vue&type=template&id=42fb6d80&scoped=true"
import script from "./PengumumanPemenangExecutive.vue?vue&type=script&lang=js"
export * from "./PengumumanPemenangExecutive.vue?vue&type=script&lang=js"

import "./PengumumanPemenangExecutive.vue?vue&type=style&index=0&id=42fb6d80&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fb6d80"]])

export default __exports__